import { ThumbnailList } from 'ui/components/3-organisms/ThumbnailList';
import { ThumbnailCardProps } from 'ui/components/2-molecules/Card/ThumbnailCard';
import { useContext } from 'react';
import { ProfileContext } from 'application/adapters/context/Profile';
import { filterItemsByAudience } from 'helpers/audiencehelper';

export const ThumbnailListFeature: React.FC<Umbraco.ThumbnailList> = ({ content }) => {

	const { audiences, isReady, audiencesFailed } = useContext(ProfileContext);
	const { items, thumbnailListHeading, thumbnailListSubHeading, moduleLink } = content?.properties ?? {};

	if (!isReady) return null;

	const mappedItems: ThumbnailCardProps[] = filterItemsByAudience(items, audiences, undefined, audiencesFailed).map(({ content }) => {
		const { heading, image, text, link, interactiveText } = content?.properties ?? {};

		return {
			heading,
			image,
			text,
			interactiveText,
			link,
			moduleLink,
			columnWidth: '25',
			imageSizes: '(max-width: 768px) 50vw, 50vw',
		};
	});

	

	return (
		<ThumbnailList
			thumbnailListHeading={thumbnailListHeading}
			thumbnailListSubHeading={thumbnailListSubHeading}
			moduleLink={moduleLink}
			columns={mappedItems.length + 1}
			items={mappedItems}
		/>
	);
};
